import CreateNewAppModal from './CreateNewAppModal.js'
import DeleteAppModal from './DeleteAppModal.js'
import ConfirmSubmissionRequestModal from './ConfirmSubmissionRequestModal.js'
import ConfirmSubmissionCancelModal from './ConfirmSubmissionCancelModal.js'
export {
	CreateNewAppModal,
	DeleteAppModal,
	ConfirmSubmissionRequestModal,
	ConfirmSubmissionCancelModal
}



// WEBPACK FOOTER //
// ./src/views/Modals/index.js